export const algoliaStringFormatter = (value: string) =>
  value
    .replace(/\[[^\]]*\]/, '')
    .replace(/^\[|\]$/g, '')
    .replaceAll(' ', '-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
